import PropTypes from 'prop-types';

const Row = ({ label, value }) => (
  <div 
      className="ng-office-app__authed__content__basket__info-modal__row"           
  >
    <div 
        className="ng-office-app__authed__content__basket__info-modal__row__key"
    >
      {label}:
    </div>
    <div 
        className="ng-office-app__authed__content__basket__info-modal__row__value"
    >
      {value}
    </div>
  </div>
)

Row.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}


export default Row;